import React, { Component } from "react";
import PropTypes from "prop-types";
import { v4 } from "uuid";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { saveAlertConfigSettings } from "../alert-edit-config-settings";
import { translate as t } from "../../../infrastructure/translate/localization";

import "./auto-close-config.scss";

export default class AutoCloseConfig extends Component {
  myRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      lastPayrollCloseFormatted: "",
      autoCloseDay: 4,
      emails: [],
      inputNewEmail: "",
      saveDisabled: true,
    };
  }

  async componentDidMount() {
    const { configSettings, company } = this.props;
    this.setState({
      autoCloseDay: parseInt(configSettings.autoCloseDay, 10),
      emails: configSettings.adjustmentEmailSubscribers,
      lastPayrollCloseFormatted: moment(company.lastPayrollCloseIsoTime).format(
        "DD-MM-YYYY"
      ),
    });

    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (e) => {
    const { inputNewEmail } = this.state;
    if (!this.myRef.current.contains(e.target)) {
      this.changeSelect(inputNewEmail);
    }
  };

  handleInputChange = (evt) => {
    this.setState({ inputNewEmail: evt.target.value });
  };

  handleInputKeyDown = (evt) => {
    const ENTER_KEY = 13;
    const SPACE_KEY = 32;
    const COMMA_KEY = 188;

    if (
      evt.keyCode === ENTER_KEY ||
      evt.keyCode === SPACE_KEY ||
      evt.keyCode === COMMA_KEY
    ) {
      let { value } = evt.target;
      if (evt.keyCode === COMMA_KEY) {
        value = value.slice(0, -1);
      }

      this.changeSelect(value);
    }
  };

  handleRemoveItem = (index) => {
    return () => {
      this.setState((state) => ({
        emails: state.emails.filter((item, i) => i !== index),
      }));
      this.setState({ saveDisabled: false });
    };
  };

  changeSelect = (value) => {
    const { inputNewEmail } = this.state;
    if (inputNewEmail.replace(/\s/g, "").length) {
      this.setState((state) => ({
        emails: [...state.emails, value],
        inputNewEmail: "",
      }));

      this.setState({ saveDisabled: false });
    }
  };

  render() {
    const { company, configSettings, selectableDays } = this.props;
    const {
      value,
      autoCloseDay,
      emails,
      inputNewEmail,
      saveDisabled,
      lastPayrollCloseFormatted,
    } = this.state;

    return (
      <div className="sub-section">
        <div className="section-header">
          <div className="cob-btn-group">
            <p className="header-subtitle">
              {t("configuration-section.program-auto-payroll-close")}
            </p>
          </div>
        </div>
        <div className="section-description">
          <p>
            {t("configuration-section.auto-payroll-close-info-1")}
            <b> {t("configuration-section.auto-payroll-close-info-2")} </b>
            {t("configuration-section.auto-payroll-close-info-3")}
            {configSettings.factorialEnabled && (
              <span className="section-info-text">
                {` ${t("configuration-section.auto-payroll-close-info-4")}`}
              </span>
            )}
          </p>
        </div>

        <div className="section-description">
          <p>
            {t("monitoring-section.payroll-close-info-1")}{" "}
            <strong>{lastPayrollCloseFormatted}</strong>
            {t("monitoring-section.payroll-close-info-2")}{" "}
            <strong>{company.autoCloseDay}</strong>{" "}
            {t("monitoring-section.payroll-close-info-3")}
          </p>
        </div>

        <div className="auto-close cob-btn-group">
          <div className="cob-input-group short-group">
            <span className="input-label">
              {t("configuration-section.day-of-payroll-close")}
            </span>
            <div className="cob-select">
              <select
                className="cob-select"
                onChange={(e) =>
                  this.setState({
                    autoCloseDay: e.target.value,
                    saveDisabled: false,
                  })
                }
                value={value}
              >
                <option disabled>
                  {t("configuration-section.day-of-payroll-close")}
                </option>
                {selectableDays.map((m) => (
                  <option selected={m === autoCloseDay} key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>
              <FontAwesomeIcon icon="chevron-down" />
            </div>
            <span
              hidden={autoCloseDay < 29}
              className="input-label warning-label"
            >
              {t("configuration-section.day-of-payroll-close-info", {
                days: autoCloseDay,
              })}
            </span>
          </div>

          <div className="cob-input-group ">
            <span className="input-label">
              {t("configuration-section.email-send")}
            </span>
            <label>
              <ul
                ref={this.myRef}
                onClick={this.handleClickInside}
                className="container-input"
                role="presentation"
              >
                {emails.map((item, i) => (
                  <li
                    className="items-tag"
                    key={v4()}
                    onClick={this.handleRemoveItem(i)}
                    role="presentation"
                  >
                    {item}
                    <FontAwesomeIcon
                      icon="trash"
                      className="trash-tag"
                      alt="delete"
                    />
                  </li>
                ))}
                <input
                  className="new-input-tag"
                  value={inputNewEmail}
                  onChange={this.handleInputChange}
                  onKeyUp={this.handleInputKeyDown}
                />
              </ul>
            </label>
          </div>
        </div>

        <div className="cob-btn-group right-group">
          <button
            type="button"
            className="cob-btn btn-primary"
            disabled={saveDisabled}
            onClick={() => {
              saveAlertConfigSettings(autoCloseDay, emails);
              this.setState({ saveDisabled: true });
            }}
          >
            {t("actions.program")}
          </button>
        </div>
      </div>
    );
  }
}

AutoCloseConfig.defaultProps = {};
AutoCloseConfig.propTypes = {
  company: PropTypes.object.isRequired,
  configSettings: PropTypes.object.isRequired,
  selectableDays: PropTypes.object.isRequired,
};
